import { render, staticRenderFns } from "./SearchQueryResults.vue?vue&type=template&id=66cbf59a&scoped=true"
import script from "./SearchQueryResults.vue?vue&type=script&lang=js"
export * from "./SearchQueryResults.vue?vue&type=script&lang=js"
import style0 from "./SearchQueryResults.vue?vue&type=style&index=0&id=66cbf59a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cbf59a",
  null
  
)

export default component.exports